import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PayModel from "./pay";
import VerifyModal from "./verifyIdentitty";
import AgreementModal from "./signAgreement";
import SubscriptionModal from "./proSubscription";
import ApplicationModal from "./channelApplication";
import { useAuth } from "../../../context/AuthContext";
import { setDoc, doc } from "firebase/firestore";

import { getUser } from "../../../api/accounts/userServices";
import { useNavigationBar } from "../../../context/NavigationContext";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { ChannelType } from "../../../models/SKChannel";
import { COLLECTIONS } from "../../../firebase/firebase";

const checks = [
  {
    title: "Pay Enrollment Fee of USD 10.00",
    desc: "Enrollment fee is a one time non-refundable fee to get your onboarding process started.",
    linkTitle: "Pay Enrollment Fee",
    doneTitle: "Enrollment Fee Paid",
    to: "pay",
  },
  {
    title: "Verify your Identity",
    desc: "ID verification helps us to keep the product safe and verify who you are.",
    linkTitle: "Start Verification",
    doneTitle: "Verification Successful",
    to: "verify-identity",
  },
  {
    title: "Submit Channel Application",
    desc: "Channel application lets us learn about you and the content you plan to publish.",
    linkTitle: "Start Channel Application",
    doneTitle: "Channel Application Approved",
    to: "submit-application",
  },
  {
    title: "Sign Agreements",
    desc: "Review and sign Terms of Service, Privacy Policy, Acceptable Use Policy and Community Guidelines.",
    linkTitle: "Review and Sign Agreements",
    doneTitle: "Reviewed and Signed",
    to: "sign-agreement",
  },
  {
    title: "Sign up for Pro Subscription",
    desc: "Pro subscription allows you to publish content and get support.",
    linkTitle: "Sign Up for Pro Subscription",
    doneTitle: "Pro Subscription Active",
    to: "pro-subscription",
  },
  {
    title: "Create your Channel",
    desc: "Setup your channel to start publishing content.",
    linkTitle: "Create Channel",
    doneTitle: "Create Channel",
    to: "create-channel",
  },
];

const Checklist = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [showPay, setShowPay] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [showApplicationn, setShowApplication] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [channelType, setChannelType] = useState<string | undefined>(undefined);
  const { setNavProps } = useNavigationBar();
  const { channelData, loading } = useContext(CreateChannelContext);
  const location = useLocation();

  useEffect(() => {
    setNavProps({
      backArrow: currentStep === 0 ? true : false,
      title: "Onboarding",
      subtitle: "Creator Onboarding",
      buttonTitle: "Create Channel",
      filterOption: false,
      enableLink: currentStep === 5 ? true : false,
      onBack: () => {
        navigate("../", { state: location.state });
      },
    });
  }, [setNavProps, currentStep, navigate]);

  useEffect(() => {
    setChannelType(location.state?.channelType);
  }, [location]);

  const authContext = useAuth();

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!authContext?.currentUser) {
        return;
      }
      //let ref = doc(authContext.db, COLLECTIONS.USERS, authContext.currentUser?.uid);
      // Create a reference to the user document
      const user = await getUser(authContext.currentUser?.uid); // Fetch the document

      if (user) {
        if (user.onboarding) {
          if (user.onboarding.payment) {
            setCurrentStep(1);
          }
          if (user.onboarding.verification) {
            setCurrentStep(2);
          }
          if (user.onboarding.application) {
            setCurrentStep(3);
          }
          if (user.onboarding.aggreement) {
            setCurrentStep(4);
          }
          if (user.onboarding.subscription) {
            setCurrentStep(5);
          }
        }
      } else {
        console.log("No such document!");
        return null; // Handle the case where the document does not exist
      }
    };
    fetchUserInfo();
  }, [authContext]);

  let element = <img src={"/icons/check.png"} className="w-[16px] h-[16px] rounded-lg" alt="" />;

  const moveNext = (e: React.FormEvent) => {
    e.preventDefault();
    if (currentStep === checks.length - 1) {
      navigate("/dashboard/channels/onboard", { state: { channelType: ChannelType.brand } });
    }
    // setCurrentStep(currentStep + 1);

    switch (currentStep) {
      case 0:
        setShowPay(true);
        break;
      case 1:
        setShowVerify(true);
        break;
      case 2:
        setShowApplication(true);
        break;
      case 3:
        setShowAgreement(true);
        break;
      case 4:
        setShowSubscription(true);
        break;
      default:
        break;
    }
  };

  // useEffect(() => {

  // }, [currentStep])

  const updateObject = async (obj: any) => {
    if (!authContext?.currentUser) {
      return;
    }
    // await setDoc(doc(db, COLLECTIONS.USERS, auth.currentUser.uid), { email, firstName, lastName, phone }, { merge: true });
    // let ref = doc(authContext.db, COLLECTIONS.USERS, authContext.currentUser?.uid);
    await setDoc(doc(authContext.db, COLLECTIONS.USERS, authContext.currentUser?.uid), obj, { merge: true });
  };

  const onSubscriptionDone = async () => {
    setShowSubscription(false);
    await updateObject({ onboarding: { subscription: true } });
    setCurrentStep(prevData => prevData + 1);
  };

  const verificationDone = async () => {
    setShowVerify(false);
    await updateObject({ onboarding: { verification: true } });
    setCurrentStep(prevData => prevData + 1);
  };
  const applicationDone = async () => {
    setShowApplication(false);
    await updateObject({ onboarding: { application: true } });
    setCurrentStep(prevData => prevData + 1);
  };
  const agreementDone = async () => {
    setShowAgreement(false);
    await updateObject({ onboarding: { aggreement: true } });
    setCurrentStep(prevData => prevData + 1);
  };
  const onPaymentDone = async () => {
    setShowPay(false);
    const userType = channelData.channelType;
    await updateObject({ onboarding: { payment: true }, userType });
    setCurrentStep(prevData => prevData + 1);
  };

  return (
    <div className="p-2 pb-20 bg-white">
      <div className="flex flex-col">
        {/* <div className="flex flex-row px-5 py-2 h-[50px] w-full justify-between">
          <div className="float-left text-2xl font-bold">Onboarding</div>
          <div className="float-right">
            <Link
              to="../create"
              className="flex items-center justify-center px-2 py-1 text-lg font-normal text-center text-white bg-black rounded-lg"
            >
              <button className="w-full h-full">Next</button>
            </Link>
          </div>
        </div> */}
        <AgreementModal isOpen={showAgreement} agreementDone={agreementDone} />
        <ApplicationModal isOpen={showApplicationn} applicationDone={applicationDone} />
        <PayModel isOpen={showPay} onPaymentDone={onPaymentDone} />
        <SubscriptionModal isOpen={showSubscription} onSubscriptionDone={onSubscriptionDone} />
        <VerifyModal isOpen={showVerify} verificationDone={verificationDone} />

        {/* <div className="w-full my-2 thickseparator" /> */}
        <div className="flex flex-col p-2">
          <div className="m-2">
            <span className="content_title">Complete the following steps to create your channel and start publishing. s</span>
          </div>
          {checks.map((data, index) => (
            <div key={index} className="flex flex-col p-3 m-2 bg-white border-2 rounded-lg border-gray">
              <div className="flex flex-row space-x-4">
                <div
                  className={
                    (currentStep === index
                      ? " text-white bg-black "
                      : currentStep > index
                      ? " bg-skgreen "
                      : " text-gray bg-white border-2 border-gray ") +
                    "flex text-lg font-bold items-center justify-center flex-shrink-0 w-[30px] h-[30px] rounded-full"
                  }
                >
                  {currentStep > index ? element : index + 1}
                </div>
                <div className="flex flex-col w-full">
                  <h2
                    className={
                      (currentStep === index ? " text-black " : currentStep > index ? " text-skgray font-bold " : " text-skgray ") +
                      "text-base font-semibold"
                    }
                  >
                    {data.title}
                  </h2>
                  <p className="pb-2 text-gray-400">{data.desc}</p>
                  <div className="w-full my-2 thinseparator" />
                  {currentStep === index ? (
                    <Link to={data.to} onClick={moveNext} className="float-left py-2 text-black">
                      {data.linkTitle}
                    </Link>
                  ) : (
                    <div className={(currentStep > index ? " text-skgreen font-bold " : "") + "float-left py-2 text-skgray"}>
                      {currentStep > index ? data.doneTitle : data.linkTitle}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Checklist;
